/**
 * Theme mode toggle component (light/dark)
 */

import { IconButton, Tooltip } from '@mui/material';
// ⚡ Path-based imports (6× faster than barrel imports)
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import type { PaletteMode } from '@mui/material';

interface ThemeToggleProps {
  mode: PaletteMode;
  onToggle: () => void;
}

export function ThemeToggle({ mode, onToggle }: ThemeToggleProps) {
  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        onClick={onToggle}
        size="small"
        aria-label="Toggle theme"
        sx={{
          color: 'text.secondary',
          transition: 'all 0.3s ease',
          '&:hover': {
            color: 'text.primary',
            transform: 'rotate(180deg)',
          },
        }}
      >
        {mode === 'light' ? (
          <DarkModeIcon fontSize="small" />
        ) : (
          <LightModeIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
